import Layout from '@/layout';
var staffRouter = {
  path: '/staff',
  component: Layout,
  redirect: '/staff/index',
  name: 'Staff',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/staff/admin/index');
    },
    name: 'StaffIndex',
    meta: {
      title: '员工管理',
      icon: ''
    }
  }]
};
export default staffRouter;